import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';

import { Loading, Logo, Padding } from '@/components/common';
import { CLUB_URL } from '@/utils/constants';

const Club: React.FC = () => {
  useEffect(() => {
    window.location.href = CLUB_URL;
  }, []);

  return (
    <IonPage id="club">
      <IonContent>
        <Padding>
          <Logo />
          <Loading />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Club;
